module.exports = __webpack_public_path__ + "img/i-0.4c0fb59d.jpg";